// extracted by mini-css-extract-plugin
module.exports = {"chartWrapper":"chartWrapper--17i2e","chartAreaWrapper":"chartAreaWrapper--2WA5L"};